import { SelectItem } from "@/components/ui/select"
import type { ReactNode } from "react"

export interface ExplainedSelectItemProps {
  value: string
  label: ReactNode
  explainer: ReactNode
}

/**
 * Two-line option shared by `GeltungSelect` and `VerdictSelect`: the label
 * (what the accessible name is computed from) plus a muted explainer line.
 * The explainer is `aria-hidden` on purpose: it must never widen the computed
 * name Radix derives for the trigger/option (`getByRole("option", { name })`
 * elsewhere pins the plain label), and a native `title` inside a listbox is
 * poor hover UX anyway (product-owner rule: app components, never `title`).
 */
export function ExplainedSelectItem({
  value,
  label,
  explainer,
}: ExplainedSelectItemProps) {
  return (
    <SelectItem value={value} className="sv2-selitem">
      <span className="flex max-w-[240px] flex-col gap-0.5 whitespace-normal py-0.5">
        <span>{label}</span>
        <span aria-hidden="true" className="text-[11px] text-grey5">
          {explainer}
        </span>
      </span>
    </SelectItem>
  )
}
